import React, {FunctionComponent, Fragment, useContext, useState} from "react";
import OurAddressItem from "./Address/OurAddressItem";
import IconSeparator from "./IconSeparator";
import Wizard from "../../ui/Wizard/Wizard";
import SelectParkingItem from "./Parking/SelectParkingItem";
import ParkingChoiceItem from "./Parking/ParkingChoiceItem";
import EnterAtItem from "./Entrance/EnterAtItem";
import ProceedToItem from "./Entrance/ProceedToItem";
import {Context} from "../../../store/context";
import AfterwardsProceedItem from "./Entrance/AfterwardsProceedItem";
import {INode} from "../../../types/INode";
import { observer } from "mobx-react";

interface IGettingToWizard{
    parkTheCar:boolean;
}

const GettingToWizard:FunctionComponent<IGettingToWizard> = observer(({parkTheCar})=> {
    const {gettingToPageStore, nodesStore} = useContext(Context);
    const {settings} = gettingToPageStore;
    const [isAlternativeParking, setIsAlternativeParking] = useState(false);

    if (!settings || nodesStore.nodes.length === 0)
        return null;

    const handleParkingSelected = (node:INode|undefined) => {
        setIsAlternativeParking(node?.id === settings.alternativeParkingId);
    }

    const addressStep = {
        key: "address",
        items: [
            <OurAddressItem/>,
            <IconSeparator icon="car"/>
        ]
    };
    const parkingStep = {
        key: "parking",
        items: [
            <ParkingChoiceItem/>,
            <SelectParkingItem onNodeSelected={handleParkingSelected}/>,
            <IconSeparator icon="walking"/>
        ]
    };
    const entranceStep = {
        key: "entrance",
        items: [
            <EnterAtItem parkTheCar={parkTheCar} isAlternative={isAlternativeParking}/>,
            <IconSeparator icon="walking"/>,
            <ProceedToItem parkTheCar={parkTheCar}/>
        ]
    };

    if (!settings.directAccess) {
        entranceStep.items.push(<IconSeparator icon="walking"/>);
        entranceStep.items.push(<AfterwardsProceedItem/>);
    }

    const steps = parkTheCar ? [addressStep, parkingStep, entranceStep] : [addressStep, entranceStep];
    return <Wizard steps={steps}/>
});

export default GettingToWizard;
